import React, { useEffect, useState } from "react";
import "./GlobalAccountSearch.css";
import { pxToRem } from "../../../utilities/uiUtils";
import GlobalAccountSearchLeftPanel from "./GlobalAccountSearchComps/GlobalAccountSearchLeftPanel";
import GlobalAccountSearchRightPanel from "./GlobalAccountSearchComps/GlobalAccountSearchRightPanel";
import { useDispatch } from "react-redux";
import { FetchGlobalAccountsRequest } from "../../../store/features/actions/globalAccounts/globalAccountsActions";

function GlobalAccountSearch({handleUpdateList}) {
  const [companyData, setCompanyData] = useState({
    company_name: [],
    industries: [],
    yearfounded: [],
    country: [],
    employees: [],
    companytypeid: null, // this will be always an interger
    region:[]
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const handleOnPageChange = (page) => {
    setCurrentPage(page);
  };
  const dispatch = useDispatch();

  useEffect(() => {
  const buildFilters = (data) => {
    const filters = [];

    // const formatArray = (arr) => {
    //   if (!Array.isArray(arr) || arr.length === 0) return null;
    //   const values = arr.map(item => item.label ?? item);
    //   const wrapped = values.map(v => `"${v}"`).join(" OR ");
    //   return `${wrapped}`;
    // };

    const formatArray = (arr) => {
      if (!Array.isArray(arr) || arr.length === 0) return null;
      const values = arr.map(v => `"${v.label ?? v}"`);
      // single value → no parentheses
      if (values.length === 1) {
        return values[0];
      }
      // multiple values → OR + parentheses
      return `(${values.join(" OR ")})`;
    };

    if (data.country?.length)
      filters.push(`country:(${formatArray(data.country)})`);

    if (data.industries?.length)
      filters.push(`industries:(${formatArray(data.industries)})`);

    if (data.yearfounded?.length)
      filters.push(`yearfounded:(${formatArray(data.yearfounded)})`);

    if (data.company_name?.length)
      filters.push(`company_name:(${formatArray(data.company_name)})`);

    // ✅ Employees Range Handling
    if (Array.isArray(data.employees) && data.employees.length > 0) {
      if (data.employees.length === 2) {
        const [a, b] = data.employees.map(v => v.label ?? v);
        filters.push(`employees:[${a} TO ${b}]`);
      } else if (data.employees.length === 1) {
        const val = data.employees[0].label ?? data.employees[0];
        filters.push(`employees:${val}`);
      }else{
        filters.push(`employees:(${formatArray(data.employees)})`);
      }
    }

    if (data.region?.length)
      filters.push(`region:(${formatArray(data.region)})`);

    if (data.companytypeid !== null && data.companytypeid !== undefined)
      filters.push(`companytypeid:${data.companytypeid}`);

    return filters;
  };

  const fq = buildFilters(companyData);

  dispatch(
    FetchGlobalAccountsRequest({
      start: ((currentPage-1) * itemsPerPage),
      rows: itemsPerPage,
      q: "*:*",
      fq : fq,
    })
  );

  // console.log("companyData : ", companyData)

}, [currentPage, itemsPerPage, companyData]);


  return (
    <div
      style={{
        // height: pxToRem(1080),
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: pxToRem(10),
        paddingTop: pxToRem(10)
      }}
    >
      <GlobalAccountSearchLeftPanel
        companyData={companyData}
        setCompanyData={setCompanyData}
      />
      <GlobalAccountSearchRightPanel
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        handleOnPageChange={handleOnPageChange}
        handleUpdateList={handleUpdateList}
      />
    </div>
  );
}

export default GlobalAccountSearch;
